import {
    Badge,
    Button,
    ListItemSecondaryAction,
    Snackbar,
} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { AiOutlineSearch } from "react-icons/ai";
import { FiSidebar } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "underscore";
import { socket, startSocketService } from "../../helpers/socketHelper";
import { IsNullOrEmpty, URLReplacer, uuidv4 } from "../../helpers/utility";
import { fetchNotificationRequest } from "../../store/notification/notification.actions";
import NotificationAPI from "../../store/notification/notification.api";
import { getNotificationList } from "../../store/notification/notification.selector";
import {
    fetchMessageRequest,
    fetchMessageUsersRequest,
    updateMessageInternal,
} from "../../store/social/social.actions";
import SocialAPI from "../../store/social/social.api";
import {
    getMessages,
    getMessageUsers,
} from "../../store/social/social.selector";
import { searchUserRequest } from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";

export default function Messenger(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    const [userId, setUserId] = useState("");
    const [joinedGuests, setJoinedGuests] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [searchText, setSearchText] = useState("");
    const [openSidebar, setOpenSidebar] = useState(false);
    const history = useNavigate();
    const { users, userProfile, comments, msgUsers, allNotifications } =
        useSelector((state) => {
            return {
                userProfile: getUserProfile(state),
                comments: getMessages(state),
                users: getSearchedUsers(state),
                msgUsers: getMessageUsers(state),
                allNotifications: getNotificationList(state),
            };
        });

    useEffect(() => {
        let uid = location && location.state && location.state.userId;
        if (uid) {
            let remaining = users.filter((x) => x._id === uid);
            setSelectedUser(remaining[0]);
            setUserId(_.sortBy([userProfile._id, remaining[0]._id]).join("_"));
        }
    }, [location]);

    useEffect(() => {
        if (IsNullOrEmpty(userId) && users.length > 0) {
            let uid = location && location.state && location.state.userId;
            if (uid) {
                let remaining = users.filter((x) => x._id === uid);
                setSelectedUser(remaining[0]);
                setUserId(
                    _.sortBy([userProfile._id, remaining[0]._id]).join("_")
                );
            }
            // else {
            //   let remaining = users.filter((x) => x._id !== userProfile._id);
            //   setSelectedUser(remaining[0]);
            //   setUserId(_.sortBy([userProfile._id, remaining[0]._id]).join("_"));
            // }
        }
    }, [users, location]);

    useEffect(() => {
        dispatch(fetchMessageUsersRequest());
        dispatch(fetchNotificationRequest());
    }, []);

    useEffect(() => {
        dispatch(searchUserRequest());
        if (!socket) {
            startSocketService();
        }

        socket.on("sendCommentMessage", (data) => {
            let req = data.data;
            req.infoUser = data.infoUser;
            req.dateCreated = moment().format();
            req.dateUpdated = moment().format();
            dispatch(updateMessageInternal(req));
        });

        socket.on("sendReactioMessage", (data) => {
            let req = data.data;
            req.infoUser = data.infoUser;
            req.dateCreated = moment().format();
            req.dateUpdated = moment().format();
            dispatch(updateMessageInternal(req));
        });

        socket.on("listAudienceMessage", (data) => {
            console.log("listAudienceMessage");
            setJoinedGuests(data.listAudience);
        });

        socket.on("joinLiveMessage", (data) => {
            setJoinedGuests([...joinedGuests, data.infoUser]);
        });
    }, [userProfile]);

    useEffect(() => {
        if (!IsNullOrEmpty(userId)) {
            let pair = userId.split("_");
            dispatch(
                fetchMessageRequest(
                    "?livestream=" + pair[0] + "&pair=" + userId
                )
            );
            handleJoin();
        }
    }, [userId]);

    const handleJoin = () => {
        if (socket) {
            socket.emit("joinLive", {
                room: userId,
                type: "guests",
                infoUser: userProfile,
            });
        }
    };

    const sendComment = () => {
        let comment = document.getElementById("sendComment").value;
        if (socket && !IsNullOrEmpty(comment)) {
            let pair = userId.split("_");
            let uid = uuidv4();
            socket.emit("sendComment", {
                room: userId,
                dataCreate: {
                    user: userProfile.fullName,
                    timesAppear: 1,
                    livestream: userId,
                    type: "Main",
                    content: comment,
                    uid: uid,
                },
                pair: userId,
                infoUser: userProfile,
            });
            let data = userProfile;
            data.attachment = userProfile.avatar.attachments;
            data.uid = uid;
            NotificationAPI.sendPushNotifications({
                userIds: pair.filter((x) => x !== userProfile._id),
                title: "Inbox",
                content: userProfile.fullName + " sent private message to you",
                type: "inbox",
                data: data,
            });

            let messagedUser = pair.filter((x) => x !== userProfile._id);
            if (messagedUser.length > 0) {
                let userInfo = _.find(users, (x) => x._id === messagedUser[0]);
                if (userInfo) {
                    let mail = `<p style="text-align: center;
            background: #8B22F9;
            color: white;
            font-weight: bold;
            line-height: 28px;
            font-size: 20px;
            padding: 12px;">
                InMail: You have a new message
            </p>
            <p style="border:1px dashed"></p>
            <p style="line-height: 30px;text-align: left;">
                <span style="color: #8B22F9;font-weight: bold;">From:</span>${
                    userProfile.fullName
                }<br />
                <span style="color: #8B22F9;font-weight: bold;">Date:</span>${moment().format(
                    "lll"
                )}<br />
                <span style="color: #8B22F9;font-weight: bold;">Subject:</span>New InMail message<br />

            </p>
            <div style="background: #f5f6fa;padding: 10px">
                <p>${comment}</p>
            </div>
            <p style="text-align: center;padding: 16px;">
                <a href="https://app.ulalive.com/page/message" style="background: #8B22F9;
                    color: white;
                    padding: 16px;
                    text-decoration: none;
                    border-radius: 16px;
                    font-weight: bold;">
                    View message
                </a>
            </p>`;
                    SocialAPI.sendEmailNotification({
                        message: mail,
                        subject: "New Message From Ulalive",
                        to: userInfo.email,
                    });
                }
            }
            document.getElementById("sendComment").value = "";
        }
    };

    let msgUserIds = msgUsers && msgUsers.map((x) => x.pair);
    let smsgUserIds =
        msgUsers &&
        _.sortBy(msgUsers, function (o) {
            return new moment(o.dateCreated);
        })
            .reverse()
            .map((x) => x.pair && x.pair.split("_"));
    smsgUserIds = [].concat(...smsgUserIds);
    smsgUserIds = _.uniq(smsgUserIds);
    let filteredUsers = users.filter((x) => x._id !== userProfile._id);

    if (!IsNullOrEmpty(searchText)) {
        filteredUsers = filteredUsers.filter((x) => {
            return (
                x.fullName.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        });
    } else if (msgUserIds) {
        filteredUsers = filteredUsers.filter((x) => {
            return (
                msgUserIds.filter((y) => y && y.indexOf(x._id) > -1).length > 0
            );
        });

        filteredUsers.sort(function (a, b) {
            return smsgUserIds.indexOf(a._id) - smsgUserIds.indexOf(b._id);
        });
    }
    if (selectedUser._id) {
        let isNew = _.find(filteredUsers, (z) => z._id === selectedUser._id);
        if (!isNew) {
            filteredUsers = [selectedUser, ...filteredUsers];
        }
    }

    if (!selectedUser._id && filteredUsers.length > 0) {
        setUserId(_.sortBy([userProfile._id, filteredUsers[0]._id]).join("_"));
        setSelectedUser(filteredUsers[0]);
    }

    const sortedComments = _.sortBy(comments, function (o) {
        return new moment(o.dateCreated);
    }).reverse();

    const curUser = _.find(users, (x) => x._id === selectedUser._id);

    if (!curUser) {
        return <p></p>;
    }

    return (
        <div className=" h-full overflow-hidden">
            <div className="p-2 sm:m-4 lg:m-0 lg:px-0 lg:py-0 h-full overflow-hidden">
                <div className="flex relative h-full">
                    <div
                        className={`${
                            openSidebar
                                ? "translate-x-0 ease-in duration-300 lg:duration-[0ms] lg:transform-none opacity-100"
                                : "-translate-x-full lg:transform-none opacity-0 lg:opacity-100 lg:duration-[0ms] ease-out duration-500"
                        } max-w-[260px] sm:max-w-[345px] absolute top-0 left-0 lg:static w-full h-full bg-white p-4 rounded-tl-lg lg:rounded-none flex justify-between flex-col`}
                    >
                        <div className="px-0.5 mb-[18px]">
                            <div className="flex justify-end mb-2 lg:hidden">
                                <button
                                    onClick={() => setOpenSidebar(false)}
                                    className="p-1 border overflow-visible border-orange-color rounded-full w-fit bg-white cursor-pointer"
                                >
                                    <IoIosArrowDown
                                        className={`rotate-90 text-orange-color `}
                                    />
                                </button>
                            </div>

                            <div className="relative">
                                <input
                                    type="search"
                                    value={searchText}
                                    onChange={(e) =>
                                        setSearchText(e.target.value)
                                    }
                                    className="py-[7px] pl-9 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-sm sm:text-sm outline-none"
                                    placeholder="Search users"
                                />
                                <AiOutlineSearch className="text-xl absolute top-2/4 -translate-y-2/4 left-[11px] text-black-60 font-bold" />
                            </div>
                        </div>

                        <div className="sidebar flex flex-col justify-between h-full overflow-y-auto">
                            <div className="pb-2">
                                <div className="space-y-2.5 ">
                                    <List>
                                        {filteredUsers.map((x) => {
                                            let newMsg =
                                                allNotifications &&
                                                allNotifications.data &&
                                                allNotifications.data.filter(
                                                    (xy) =>
                                                        xy.type === "inbox" &&
                                                        !xy.isRead &&
                                                        xy.content.data._id ===
                                                            x._id
                                                );
                                            return (
                                                <ListItem
                                                    selected={
                                                        x._id ===
                                                        selectedUser._id
                                                    }
                                                    button
                                                    key={x._id}
                                                    onClick={() => {
                                                        setTimeout(() => {
                                                            if (newMsg) {
                                                                NotificationAPI.updateReadNotificationByIds(
                                                                    newMsg.map(
                                                                        (ty) =>
                                                                            ty._id
                                                                    )
                                                                ).finally(() =>
                                                                    dispatch(
                                                                        fetchNotificationRequest()
                                                                    )
                                                                );
                                                            }
                                                        }, 3000);

                                                        socket.emit(
                                                            "leftLive",
                                                            {
                                                                room: userId,
                                                                type: "guests",
                                                                infoUser:
                                                                    userProfile,
                                                            }
                                                        );
                                                        setUserId(
                                                            _.sortBy([
                                                                userProfile._id,
                                                                x._id,
                                                            ]).join("_")
                                                        );
                                                        setSelectedUser(x);
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <Avatar
                                                            alt={x.fullName}
                                                            src={getImage(
                                                                x.attachments
                                                            )}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={x.fullName}
                                                        secondary={
                                                            "@" +
                                                            x.account.userName
                                                        }
                                                        classes={{
                                                            primary:
                                                                "overflow-text",
                                                        }}
                                                    ></ListItemText>
                                                    <ListItemSecondaryAction>
                                                        {newMsg &&
                                                            newMsg.length >
                                                                0 && (
                                                                <Badge
                                                                    badgeContent={
                                                                        newMsg.length
                                                                    }
                                                                    color="secondary"
                                                                >
                                                                    <MailIcon color="primary" />
                                                                </Badge>
                                                            )}
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1 lg:px-3 lg:py-3 h-full lg:ml-[345px] sm:ml-[0px]">
                        <div className="flex flex-col h-full justify-between bg-white border border-black-10 pb-2.5">
                            <div className="pl-2 sm:pl-4 lg:px-0 flex items-center">
                                <FiSidebar
                                    onClick={() => setOpenSidebar(true)}
                                    className="text-2xl text-orange-color cursor-pointer lg:hidden"
                                />

                                <div className="px-2 sm:px-4 py-2.5 w-full flex items-center gap-x-2 border-b border-black-10">
                                    <img
                                        src={
                                            userId === userProfile._id
                                                ? getImage(
                                                      userProfile.avatar
                                                          .attachments
                                                  )
                                                : getImage(curUser.attachments)
                                        }
                                        alt=""
                                        className="rounded-full w-12 h-12"
                                    />
                                    <div className="">
                                        <h5 className="text-sm sm:text-base font-bold text-black-color leading-5">
                                            {userId === userProfile._id
                                                ? userProfile.fullName
                                                : curUser.fullName}
                                        </h5>
                                        <p className="text-sm sm:text-sm font-normal text-black-60 m-0">
                                            @
                                            {userId === userProfile._id
                                                ? curUser.account.userName
                                                : curUser.account.userName}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Messages Start Here  */}
                            <div className="flex-grow flex flex-col-reverse space-y-2 overflow-y-auto px-2 sm:px-4 chat-scrollbar-thumb chat-scrollbar-track chat-scrollbar scroll-touch text-black/80 text-base font-medium  scroll-smooth pt-2">
                                {_.unique(comments, (z) => z.code)
                                    .sort(
                                        (a, b) =>
                                            moment(a.dateCreated).unix() -
                                            moment(b.dateCreated).unix()
                                    )
                                    .reverse()
                                    .map((x) => {
                                        if (
                                            (x.infoUser._id ===
                                                userProfile._id &&
                                                !x.uid.startsWith("EV")) ||
                                            (x.uid.startsWith("EV") &&
                                                userProfile._id ===
                                                    "63bea0b804ea5436cf0e60b8")
                                        ) {
                                            return (
                                                <div className="chat-message">
                                                    <div className="flex items-start justify-end">
                                                        <div className="flex flex-col-reverse text-sm sm:text-sm max-w-[70%] order-1 items-start">
                                                            <div className=" mx-2 text-left">
                                                                <span className="pl-3 sm:pl-2 md:pl-4 pr-3 sm:pr-4 md:pr-5 py-1.5 md:py-2 bg-[#F3E9FD] inline-block rounded-lg rounded-br-none chat-shadow">
                                                                    {ReactHtmlParser(
                                                                        URLReplacer(
                                                                            x.content
                                                                        ),
                                                                        true
                                                                    )}
                                                                </span>
                                                                <p className="text-[10px] font-medium text-black-60 uppercase opacity-50 mt-0.5 leading-3">
                                                                    <time>
                                                                        {moment(
                                                                            x.dateCreated
                                                                        ).fromNow()}
                                                                    </time>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <img
                                                            src={
                                                                x.uid.startsWith(
                                                                    "EV"
                                                                ) &&
                                                                userProfile._id ===
                                                                    "63bea0b804ea5436cf0e60b8"
                                                                    ? getImage(
                                                                          userProfile
                                                                              .avatar
                                                                              .attachments
                                                                      )
                                                                    : x.infoUser &&
                                                                      x.infoUser
                                                                          .avatar &&
                                                                      x.infoUser
                                                                          .avatar
                                                                          .attachments
                                                                    ? getImage(
                                                                          x
                                                                              .infoUser
                                                                              .avatar
                                                                              .attachments
                                                                      )
                                                                    : getImage(
                                                                          x
                                                                              .infoUser
                                                                              .attachments
                                                                      )
                                                            }
                                                            className="rounded-full order-2 w-8 lg:w-10 aspect-square"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <div className="chat-message my-4">
                                                    <div className="flex items-start justify-start">
                                                        <div className="flex flex-col-reverse space-y-2 text-sm sm:text-sm max-w-[300px] lg:max-w-[400px] order-2 items-start">
                                                            <div className=" mx-2 text-left">
                                                                <span className="pl-2 sm:pl-3 md:pl-4 pr-3 sm:pr-4 md:pr-5 py-1.5 md:py-2 inline-block rounded-lg rounded-tl-none border-[0.5px] border-black-10 chat-shadow">
                                                                    {ReactHtmlParser(
                                                                        URLReplacer(
                                                                            x.content
                                                                        ),
                                                                        true
                                                                    )}
                                                                </span>
                                                                <p className="text-[10px] font-medium text-black-60 uppercase opacity-50 mt-0.5 leading-3">
                                                                    <time>
                                                                        {moment(
                                                                            x.dateCreated
                                                                        ).fromNow()}
                                                                    </time>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <img
                                                            src={
                                                                x.uid.startsWith(
                                                                    "EV"
                                                                ) &&
                                                                userProfile._id ===
                                                                    "63bea0b804ea5436cf0e60b8"
                                                                    ? getImage(
                                                                          userProfile
                                                                              .avatar
                                                                              .attachments
                                                                      )
                                                                    : x.uid.startsWith(
                                                                          "EV"
                                                                      )
                                                                    ? getImage(
                                                                          selectedUser.attachments
                                                                      )
                                                                    : x.infoUser &&
                                                                      x.infoUser
                                                                          .avatar &&
                                                                      x.infoUser
                                                                          .avatar
                                                                          .attachments
                                                                    ? getImage(
                                                                          x
                                                                              .infoUser
                                                                              .avatar
                                                                              .attachments
                                                                      )
                                                                    : getImage(
                                                                          x
                                                                              .infoUser
                                                                              .attachments
                                                                      )
                                                            }
                                                            className="rounded-full order-1 w-8 lg:w-12 aspect-square"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })}
                            </div>

                            {/* Message End  */}
                            <div className="px-4 mt-2">
                                <div className="relative">
                                    <input
                                        id="sendComment"
                                        type="text"
                                        disabled={userProfile.role === "Basic"}
                                        placeholder={
                                            userProfile.role === "Basic"
                                                ? "Upgrade to PRO to send message"
                                                : "Type your message here..."
                                        }
                                        onKeyPress={(e) => {
                                            if (e.key == "Enter") {
                                                sendComment();
                                            }
                                        }}
                                        className="w-full rounded-full border border-black-10 outline-none py-3 sm:py-[17px] text-black-color pl-2.5 sm:pl-[18px] pr-[160px] sm:pr-48 text-sm sm:text-sm placeholder:text-black-60"
                                    />
                                    <div className="flex items-center gap-x-2 sm:gap-x-4 absolute top-2/4 -translate-y-2/4 right-2.5 sm:right-[18px]">
                                        {/* <span className="text-black/50 w-7 h-7 sm:w-8 sm:h-8 flex justify-center items-center border border-black-10 rounded-full cursor-pointer hover:border-orange-color hover:text-orange-color duration-100 ease-linear">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            className="stroke-current"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.87868 10.1213C7.05025 11.2929 8.94975 11.2929 10.1213 10.1213M10.25 6.5H10.2425M5.75 6.5H5.7425M1.25 8C1.25 11.7279 4.27208 14.75 8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 4.27208 11.7279 1.25 8 1.25C4.27208 1.25 1.25 4.27208 1.25 8Z"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                    <span className="text-black/50 w-7 h-7 sm:w-8 sm:h-8 flex justify-center items-center border border-black-10 rounded-full cursor-pointer hover:border-orange-color hover:text-orange-color duration-100 ease-linear">
                                        <svg
                                            width="15"
                                            height="16"
                                            viewBox="0 0 15 16"
                                            className="stroke-current"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.37868 4.25L4.43934 9.18934C3.85355 9.77513 3.85355 10.7249 4.43934 11.3107C5.02513 11.8964 5.97488 11.8964 6.56066 11.3107L11.3713 6.37132C12.5429 5.19975 12.5429 3.30025 11.3713 2.12868C10.1997 0.957107 8.30025 0.957107 7.12868 2.12868L2.31802 7.06802C0.56066 8.82538 0.56066 11.6746 2.31802 13.432C4.07538 15.1893 6.92462 15.1893 8.68198 13.432L13.375 8.75"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span> */}
                                        <button
                                            onClick={() => sendComment()}
                                            className="px-1.5 sm:px-[13px] py-1.5 sm:py-[7px] flex items-center text-sm font-bold bg-orange-color text-white rounded-lg"
                                        >
                                            <span className="text-white inline-block mr-2">
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    className="stroke-current"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M2.75 8L1.25 14.75L14.75 8L1.25 1.25L2.75 8ZM2.75 8L8.75 8"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                            <span>Send</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar
                open={userProfile.role !== "Pro"}
                anchorOrigin={{
                    horizontal: "center",
                    vertical: "bottom",
                }}
            >
                <Alert
                    severity="info"
                    action={
                        <Button
                            color="primary"
                            onClick={() => history("/page/upgradePlan")}
                            variant="contained"
                        >
                            Upgrade Pro
                        </Button>
                    }
                >
                    Please upgrade to Pro to reply to the message over InMail
                </Alert>
            </Snackbar>
            {/* <div className="flex bg-white rounded-lg border border-black-10 w-full relative overflow-hidden h-full">
                <Grid container spacing={1} className={classes.chatSection}>
                    <Grid item md={3} lg={3} sm={12} xs={12} className={classes.borderRight500}>
                        <Card elevation={0} >
                            <CardContent>
                                <h5 className="text-xl font-medium text-black-60 mb-2">
                                    InMail
                                </h5>
                                <input
                                    placeholder="Search user.."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="peer duration-300 ease-linear cursor-pointer w-full h-11 rounded-full border border-black-10 bg-transparent pl-3 md:pl-3 outline-none focus:cursor-text focus:border-orange-color focus:pl-11 focus:pr-4 placeholder:hidden"
                                />
                                <List style={{ height: "calc(100vh - 211px)", overflowY: "auto" }}>
                                    {
                                        filteredUsers.map((x) => {
                                            let newMsg = allNotifications && allNotifications.data && allNotifications.data.filter((xy) =>
                                                xy.type === "inbox" && !xy.isRead &&
                                                xy.content.data._id === x._id);
                                            return <ListItem selected={x._id === selectedUser._id} button key={x._id}
                                                onClick={() => {
                                                    setTimeout(() => {
                                                        if (newMsg) {
                                                            NotificationAPI.updateReadNotificationByIds(
                                                                newMsg.map((ty) => ty._id)
                                                            ).finally(() => dispatch(fetchNotificationRequest()))
                                                        }
                                                    }, 3000)

                                                    socket.emit("leftLive", {
                                                        room: userId,
                                                        type: "guests",
                                                        infoUser: userProfile
                                                    });
                                                    setUserId(_.sortBy([userProfile._id, x._id]).join("_"))
                                                    setSelectedUser(x);
                                                }}>
                                                <ListItemIcon>
                                                    <Avatar alt={x.fullName} src={getImage(x.attachments)} />
                                                </ListItemIcon>
                                                <ListItemText primary={x.fullName} secondary={"@" + x.account.userName}
                                                    classes={{
                                                        primary: "overflow-text"
                                                    }}
                                                ></ListItemText>
                                                <ListItemSecondaryAction>
                                                    {newMsg && newMsg.length > 0 && <Badge badgeContent={newMsg.length} color="secondary">
                                                        <MailIcon color="primary" />
                                                    </Badge>}
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        })
                                    }
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item md={9} lg={9} sm={12} xs={12} >
                        <Card elevation={0}>
                            <CardContent>
                                {
                                    selectedUser._id ?
                                        <List disablePadding>
                                            <ListItem button disableGutters>
                                                <ListItemIcon>
                                                    <Avatar alt={selectedUser.fullName} src={getImage(selectedUser.attachments)} />
                                                </ListItemIcon>
                                                <ListItemText primary={selectedUser.fullName} secondary={"@" + selectedUser.account.userName} ></ListItemText>
                                            </ListItem>
                                        </List> :
                                        <List disablePadding>
                                            <ListItem button disableGutters>
                                                <ListItemText primary={<p className="text-secondary">Welcome <b className="text-primary">{userProfile.fullName}</b></p>}></ListItemText>
                                            </ListItem>
                                        </List>
                                }
                                <Divider />
                                {
                                    selectedUser._id ?
                                        <List className={classes.messageArea}>
                                            {
                                                _.unique(sortedComments, z => z.code).map((x) => {
                                                    let cur = _.find(users, y => y._id === x.infoUser._id);
                                                    let newMsg = allNotifications && allNotifications.data && allNotifications.data.filter((xy) =>
                                                        xy.type === "inbox" && !xy.isRead).filter((xy) => {
                                                            return xy.content.data.uid === x.uid
                                                        });

                                                    if (x.infoUser._id === userProfile._id) {

                                                        return <ListItem  >
                                                            <ListItemText
                                                                style={{ textAlign: x.infoUser._id === userProfile._id ? "right" : "left" }}
                                                                primary={<p>{x.infoUser.fullName}&nbsp;<span className="text-grey-small">@{cur.account.userName}</span></p>}
                                                                secondary={<p>
                                                                    <span className={newMsg && newMsg.length > 0 ? "msg-background-active" : "msg-background"}>
                                                          
            <span className="pl-3 sm:pl-2 md:pl-4 pr-3 sm:pr-4 md:pr-5 py-1.5 md:py-2 bg-[#F3E9FD] inline-block rounded-lg rounded-br-none chat-shadow">
                {ReactHtmlParser(URLReplacer(x.content), true)}
            </span>
        </span>
                                                                    {
        newMsg && newMsg.length > 0 &&
            <CheckCircle onClick={() => {
                if (newMsg.length > 0) {
                    let nid = _.find(newMsg, tx => tx.uid === x.uid || (tx.content && tx.content.data && x.uid === tx.content.data.uid));
                    if (nid) {
                        NotificationAPI.updateReadNotificationByIds(
                            [nid._id]
                        ).finally(() => dispatch(fetchNotificationRequest()))
                    }
                }
            }} />
    }
                                                                    <br />
                                                                    <span className={x.infoUser._id !== userProfile._id ? "text-grey-small float-left" : "text-grey-small float-right"}>{moment(x.dateCreated).format("DD-MM-YYYY hh:mm a")}</span>

                                                                </p >
                                                                } />
    < ListItemAvatar style = {{ alignSelf: "baseline", marginTop: 16 }}>
        <Avatar
            className="ml-2"
            src={x.infoUser && x.infoUser.avatar && x.infoUser.avatar.attachments ?
                getImage(x.infoUser.avatar.attachments) :
                getImage(x.infoUser.attachments)} alt="pp"
            onClick={() => {
                if (userProfile._id === x.infoUser._id) {
                    history("/" + userProfile.account.userName);
                    dispatch(fetchUserProfileRequest());
                }
                else {
                    dispatch(fetchOtherUserProfileRequest(x.infoUser._id, history));
                }
            }}
        />
                                                            </ListItemAvatar >

                                                        </ListItem >
                                                    }
                                                    else {
    return <ListItem onClick={() => {
        if (newMsg.length > 0) {
            NotificationAPI.updateReadNotificationByIds(
                newMsg.map((ty) => ty._id)
            ).finally(() => dispatch(fetchNotificationRequest()))
        }
    }}>
        <ListItemAvatar style={{ alignSelf: "baseline", marginTop: 16 }}>
            <Avatar
                src={x.infoUser && x.infoUser.avatar && x.infoUser.avatar.attachments ?
                    getImage(x.infoUser.avatar.attachments) :
                    getImage(x.infoUser.attachments)} alt="pp"
                onClick={() => {
                    if (userProfile._id === x.infoUser._id) {
                        history("/" + userProfile.account.userName);
                        dispatch(fetchUserProfileRequest());
                    }
                    else {
                        dispatch(fetchOtherUserProfileRequest(x.infoUser._id, history));
                    }
                }}
            />
        </ListItemAvatar>
        <ListItemText
            style={{ textAlign: x.infoUser._id === userProfile._id ? "right" : "left" }}
            primary={<p>{x.infoUser.fullName}&nbsp;<span className="text-grey-small">@{cur.account.userName}</span></p>}
            secondary={<p className="chat-message">
                <span className={newMsg && newMsg.length > 0 ? "msg-background-active" : "msg-background"}>
                    <span className="pl-3 sm:pl-2 md:pl-4 pr-3 sm:pr-4 md:pr-5 py-1.5 md:py-2 bg-[#F3E9FD] inline-block rounded-lg rounded-br-none chat-shadow">
                        {ReactHtmlParser(URLReplacer(x.content), true)}
                    </span>
                </span>
                {
                    newMsg && newMsg.length > 0 &&
                    <CheckCircle onClick={() => {
                        if (newMsg.length > 0) {
                            let nid = _.find(newMsg, tx => tx.uid === x.uid || (tx.content && tx.content.data && x.uid === tx.content.data.uid));
                            if (nid) {
                                NotificationAPI.updateReadNotificationByIds(
                                    [nid._id]
                                ).finally(() => dispatch(fetchNotificationRequest()))
                            }
                        }
                    }} />
                }
                <br />
                <span className={x.infoUser._id !== userProfile._id ? "text-grey-small float-left" : "text-grey-small float-right"}>{moment(x.dateCreated).format("DD-MM-YYYY hh:mm a")}</span>

            </p>
            } />

    </ListItem>
}
                                                })
                                            }
                                        </List > :
<div align="center" className="default-msg center-div">
    <img src={logo} alt="logo" width={64} className="mb-3" />
    <h4 className="text-primary">Welcome to Ulalive!</h4>
    <h6 className="text-secondary">Click the users and start messaging them.</h6>
</div>
                                }
<Divider />
{
    selectedUser._id &&

        <TextField
            fullWidth
            color="secondary"
            disabled={userProfile.role === "Basic"}
            placeholder={userProfile.role === "Basic" ? "Upgrade to PRO to send message" : "Type message"}
            className="m-1"
            variant="outlined"
            onKeyPress={(e) => {
                if (e.key == "Enter") {
                    sendComment();
                }
            }}
            inputProps={{
                id: "sendComment"
            }}
            InputProps={{
                endAdornment: <InputAdornment position="end">
                    <Button style={{ display: userProfile.role === "Basic" ? "none" : "block" }} onClick={() => sendComment()} variant="contained" color="secondary">
                        Send
                    </Button>
                </InputAdornment>
            }}
        />
}
                            </CardContent >
                        </Card >

                    </Grid >
                </Grid >

         
</div > */}
        </div>
    );
}
